import ContentManagmentApi from "../../../services/api/contentManagmentApi.js";

const ContentManagmentApiService = new ContentManagmentApi();

export default {
  data() {
    return {
      featured: [],
    };
  },

  methods: {
    getLandingCollection,
    redirect,
  },
  beforeMount() {
    this.getLandingCollection();
  },
};

function redirect(name, id) {
  this.$router.push(`/collection/${name}/${id}`);
}

function getLandingCollection() {
  ContentManagmentApiService.getFeaturedCollections()
    .then((response) => {
      this.featured = response.data;
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error("Featured Component error: " + error));
      }
    });
}
